import { Component, Host, h, Element, Prop } from "@stencil/core";
import pfx from "../../utils/style-class-prefix-helper";
import { BADGES_ALIGNMENT_LEFT, BADGES_MOBILE_LAYOUT_2COL } from "./constants/badges-constants";
import { BadgesAlignment, BadgesMobileLayout } from "./constants/badges-types";

/**
 * @slot [unnamed] - holds up to 6 eon-ui-badge components.
 */
@Component({
  tag: "eon-ui-badges",
  styleUrl: "badges.scss",
  shadow: true
})
export class Badges {
  badges: HTMLEonUiBadgeElement[];

  @Element() hostElement: HTMLEonUiBadgesElement;

  /**
   * Alignment of badges group.
   * @default left
   */
  @Prop() alignment: BadgesAlignment = BADGES_ALIGNMENT_LEFT;

  /**
   * Defines if there should be a three column or a two column layout on mobile devices if there is enough space available.
   * @default 2col
   */
  @Prop() mobileLayout: BadgesMobileLayout = BADGES_MOBILE_LAYOUT_2COL;

  componentWillLoad() {
    this.badges = Array.from(this.hostElement.children as HTMLCollectionOf<HTMLEonUiBadgeElement>);
  }

  componentDidLoad() {}

  render() {
    return (
      <Host>
        <div
          class={pfx({
            "badges-wrapper": true,
            [`alignment-${this.alignment}`]: !!this.alignment,
            [`mobile-width-${this.mobileLayout}`]: !!this.mobileLayout
          })}
        >
          {this.badges.map((badge) => {
            return (
              <div
                class={pfx({
                  "badge-wrapper": true
                })}
                innerHTML={`${badge.outerHTML}`}
              ></div>
            );
          })}
        </div>
      </Host>
    );
  }
}
